module.exports = __webpack_public_path__ + "static/kancchalannka-0c297022bba9ba7bdec620843fe6b956.png";